import type { FC } from "react";
import { MouseEvent } from "react";

import { t } from "i18n/i18n";
import { AddReferenceKeys } from "i18n/i18next";
import { SquareIconButton, SquareIconButtonSize } from "mds/components/buttons/SquareIconButton";
import { AddPlusIcon } from "mds/icons";

export interface AddIconButtonProps {
  onClick: () => void;
  reference: AddReferenceKeys;
  eventPrefix?: string;
  size?: SquareIconButtonSize;
}

export const ToolbarAddIconButton: FC<AddIconButtonProps> = ({
  onClick,
  reference,
  eventPrefix,
  size = "s",
}) => {
  return (
    <SquareIconButton
      className="p-2"
      eventName={eventPrefix ? `${eventPrefix}Add` : undefined}
      kind="ghost"
      size={size}
      title={t("edit_delete_widget.add", { context: reference })}
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <AddPlusIcon />
    </SquareIconButton>
  );
};
